<template>
  <div class="main">
    <div class="banner">
      <div class="banner-left">
        <div class="title">{{ $t('News.title') }}</div>
        <div class="title">{{ $t('News.title2') }}</div>
        <div style="margin-top: 25px; margin-right: 115px;">
          <div class="content">{{ $t('News.content') }}</div>
          <div class="content">{{ $t('News.content2') }}</div>
        </div>
      </div>

      <div class="banner-right">
        <img :src="require('../assets/server/News.png')" alt="" />
      </div>
    </div>

    <Board />

    <div class="container3">
      <div class="finance_table">
        <div
          class="finance"
          v-for="(item, index) in newsList"
          :key="item.newNo || index"
          style="border-bottom: 1px dashed #ccc; margin-bottom: 10px; padding-bottom: 10px;"
          @mouseenter="hoverFinanceIndex = index"
          @mouseleave="hoverFinanceIndex = null"
          :class="{ 'is-hovered': hoverFinanceIndex === index }"
        >
          <div
            class="finance_picture"
            :style="{
              backgroundImage: item.coverUrl ? 'url(' + getCoverUrl(item.coverUrl) + ')' : '',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center'
            }"
          ></div>
          <div class="finance_date">
            <span>{{ formatDate(item.createTime).monthDay }}</span><br><span>{{ formatDate(item.createTime).year }}</span>
          </div>
          <div class="finance_title" @click="$router.push({ name: 'Detail', query: { newNo: item.newNo } })">{{ truncate(item.title, 18) }}</div>
          <div class="finance_content">{{ item.summary }}</div>
          <img
            class="finance-icon"
            :src="hoverFinanceIndex === index ? require('../assets/News/open1.png') : require('../assets/News/open2.png')"
            alt="打开"
            @click="$router.push({ name: 'Detail', query: { newNo: item.newNo } })"
          />
        </div>

        <div v-if="newsList.length === 0" style="text-align:center;color:#9aa;">暂无数据</div>
      </div>

      <div class="page">
        <div
          class="page-left"
          style="margin-right: 10px; cursor: pointer;"
          @click="prevPage"
          :style="{ opacity: currentPage <= 1 ? 0.5 : 1, pointerEvents: currentPage <= 1 ? 'none' : 'auto' }"
        ></div>

        <div class="page-now" style="margin-right: 10px;">{{ currentPage }}</div>

        <div class="page-number" style="margin-right: 10px;">
          <div class="page-number-item" v-if="totalPage - currentPage > 1">···</div>
          <div
            class="page-number-item"
            v-if="totalPage > currentPage"
            @click="gotoPage(totalPage)"
            :style="{ cursor: 'pointer' }"
          >{{ totalPage }}</div>
        </div>

        <div
          class="page-right"
          @click="nextPage"
          :style="{ opacity: isLastPage ? 0.5 : 1, pointerEvents: isLastPage ? 'none' : 'auto', cursor: 'pointer' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Board from '@/components/Board.vue'
import { newsPage } from '@/api/New.ts'

export default {
  name: 'News',
  components: { Board },
  data() {
    return {
      hoverFinanceIndex: null,
      newsList: [],
      currentPage: 1,
      pageSize: 6,
      totalPage: 1,
      isLastPage: false
    }
  },
  mounted() {
    // 移除：console.log('News mounted: start loadNews')
    this.loadNews(this.currentPage)
  },
  methods: {
    async loadNews(pageNo = 1) {
      try {
        // 移除：console.log('loadNews pageNo:', pageNo)
        const lang = localStorage.getItem('langue');
        const req = { pageNo, pageSize: this.pageSize };
        if (lang !== null) {
          req.isEnglish = (lang === 'en');
        }

        const res = await newsPage(req);
        // 移除：console.log('newsPage json:', JSON.stringify(res, null, 2))

        const result = res && res.result
          ? res.result
          : (res && res.data && res.data.result) ? res.data.result
          : null

        const fullList = result && Array.isArray(result.list) ? result.list : []
        const offset = (pageNo - 1) * this.pageSize

        if (fullList.length > this.pageSize) {
          // 后端返回整表：前端按页码截取
          this.newsList = fullList.slice(offset, offset + this.pageSize)
          this.totalPage = Math.max(1, Math.ceil(fullList.length / this.pageSize))
          this.isLastPage = pageNo >= this.totalPage
        } else {
          // 后端返回每页数据：直接使用
          this.newsList = fullList
          this.isLastPage = this.newsList.length < this.pageSize
          // 若无总页信息，保守更新 totalPage
          if (typeof result.totalPage === 'number') {
            this.totalPage = Math.max(1, result.totalPage)
          } else if (typeof result.totalCount === 'number') {
            this.totalPage = Math.max(1, Math.ceil(result.totalCount / this.pageSize))
          } else if (this.isLastPage) {
            this.totalPage = Math.max(this.totalPage, pageNo)
          }
        }

        this.currentPage = pageNo
        console.log(
          'parsed newsList length:', this.newsList.length,
          'currentPage:', this.currentPage,
          'totalPage:', this.totalPage,
          'isLastPage:', this.isLastPage,
          'newNos:', this.newsList.map(i => i.newNo)
        )
      } catch (e) {
        console.error('新闻分页加载失败:', e)
        this.newsList = []
      }
    },
    getCoverUrl(url) {
      if (!url) return ''
      if (url.startsWith('http://localhost:9016')) {
        return url.replace('http://localhost:9016', 'http://192.168.56.109:9016')
      }
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      return `http://192.168.56.109:9016${url.startsWith('/') ? '' : '/'}${url}`
    },
    gotoPage(page) {
      if (!page || page < 1) return
      const target = Math.min(Math.max(1, page), this.totalPage)
      if (target !== this.currentPage) {
        this.loadNews(target)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.loadNews(this.currentPage - 1)
      }
    },
    truncate(text, maxLen) {
      if (text === null || text === undefined) return ''
      const s = String(text)
      return s.length > maxLen ? s.slice(0, maxLen) + '...' : s
    },
    formatDate(input) {
      if (!input) return { monthDay: '', year: '' }
      const str = String(input)
      const parts = str.split(/[^\d]/).filter(Boolean)
      if (parts.length >= 3) {
        const year = parts[0]
        const month = parts[1].padStart(2, '0')
        const day = parts[2].padStart(2, '0')
        return { monthDay: `${month}/${day}`, year }
      }
      const d = new Date(str)
      if (!isNaN(d.getTime())) {
        const year = String(d.getFullYear())
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return { monthDay: `${month}/${day}`, year }
      }
      return { monthDay: str, year: '' }
    },
    nextPage() {
      if (!this.isLastPage) {
        this.loadNews(this.currentPage + 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  margin-top: 50px;

  .banner {
    /* 固定画布宽度与居中 */
    
    margin: 0 auto;
  min-width: 1200px;
    position: relative;
    height: 576px;
    
    background-image: url('../assets/home/RWAbackground.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    /* 固定画布宽度，居中，不随视口变化 */
    width: 100%;
    
    
      display: flex;
        justify-content: center;
        align-items: center;
       
        box-sizing: border-box;

       .banner-left {
            flex: 1 1 auto;
            max-width: 1000px;
            text-align: left;
            z-index: 2;
            position: relative;
            left: 150px;
            /* 标题样式 */
            .title {
                color: #ffffff;
                font-size: 70px;
                font-weight: 700;
                line-height: 1.6;
                margin-bottom: 10px;
                font-family: 'Arial', sans-serif;
                max-width: 1600px;
            }
           
            /* 内容文本样式 */
            .content {
                font-family: 'Arial', sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #aaa9a9a2;
                max-width: 100%;
                line-height: 1.4;
            }
        }

        /* 横幅右侧图片区域 */
        .banner-right {
            top:10px;
            left:-150px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;
            position: relative;
            
            img {
                width: 100%;
                height: auto;
                scale: 0.9;
                
            }
        }
  }

  .container3 {
    background-image: url('../assets/background/background2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
     min-width: 1200px;
    /* 固定画布宽度与居中 */
    width: 100%;
    
    margin: 0 auto;
    position: relative;

    
    

    padding-top: 50px;
  

  .finance.is-hovered {
    background-image: url('../assets/News/newschoose.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: 207px; /* 原为 10.8vw，按 1920 设计约等于 207px */
  }

  .finance.is-hovered .finance_title {
    color: #ff0000;
  }

  .finance_table {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 1209.6px;
    left: 0px;
    
     margin: 0 auto;
    .finance {
      position: relative;
      height: 220px;
    }

    .finance_title {
      font-size: 34px;
      font-weight: 400;
      line-height: 1.6;
      margin-bottom: 0px;
      font-family: '微软雅黑';
      color: #b4b2b2;
      top: 30px;
      left: 350px;
      position: relative;
      z-index: 10;
    }

    .finance_content {
      font-size: 21px;
      font-weight: 200;
      line-height: 1.6;
      margin-bottom: 0px;
      font-family: '微软雅黑';
      color: #8a8888;
      top: 30px;
      left: 350px;
      position: relative;
      width: 700px;
      height: auto;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: anywhere;
      z-index: 10;
      
    }
  }

  .page {
    padding-top: 100px;
    margin-left: 845px;
    display: flex;
    align-items: center;
    margin: 0 auto;
     
    justify-content: center;
    align-items: center;
    position: relative;
    padding-bottom: 60px;
  }

  .page-left {
    background-image: url('../assets/global/left.png');
    width: 40px;
    height: 40px;
  }

  .page-now {
    background-image: url('../assets/global/now.png');
    width: 40px;
    height: 40px;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    padding-top: 5px;
  }

  .page-number {
    display: flex;
    align-items: center;
    height: 40px;
  }

  .page-number-item {
    background-image: url('../assets/global/pages.png');
    background-size: contain;
    background-repeat: no-repeat;
    width: 35px;
    height: 35px;
    margin-right: 5px;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    padding-top: 2px;
  }

  .page-number-item:last-child {
    margin-right: 0;
  }

  .page-right {
    background-image: url('../assets/global/rihgt.png');
    width: 40px;
    height: 40px;
  }

  .finance-icon {
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    scale: 1.2;
  }

  .finance::before {
    content: '';
    position: absolute;
    left: 26%;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 75%;
    border-left: 1px solid #7e7d7d;
    pointer-events: none;
  }

  .finance_date {
    font-family: '微软雅黑';
    color: #8a8888;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: calc(26% - 90px);
    width: 80px;
    text-align: right;
    z-index: 10;
    
  }

  .finance_picture {
    position: absolute;
    top: 50%;
    height: 80%;
    transform: translateY(-50%);
    left: 10px;
    z-index: 102;
    width: 240px;
  }
}
}
</style>